
import React from 'react';
import PitchPlayground from '@/components/pitch/PitchPlayground';
import { Toaster } from '@/components/ui/toaster';

const PitchPlaygroundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="container mx-auto px-4 py-8 flex-grow">
        <h1 className="text-3xl font-bold mb-6">Pitch Playground</h1>
        <PitchPlayground />
      </main>
      <Toaster />
    </div>
  );
};

export default PitchPlaygroundPage;
